import type {SVGProps} from 'react'
const DeliveryDhlIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 42 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={42} height={9.26856} fill="#FFCC00" />
    <g>
      <path
        d="M6.5 3.07L9.84 0H14.1C14.5 0 14.5 0.12 14.3 0.32C14.1 0.53 13.75 1 13.54 1.26C13.44 1.39 13.26 1.65 13.87 1.65H19C18.6 2.19 17.28 3.66 14.92 3.66H6.5V3.07Z"
        fill="#D40511"
      />
      <path d="M20.56 1.65L19 3.66H14.85L16.41 1.65H20.56Z" fill="#D40511" />
      <path d="M26.32 1.65L24.76 3.66H20.61L22.17 1.65H26.32Z" fill="#D40511" />
      <path
        d="M27.64 1.65C27.64 1.65 27.34 2.05 27.2 2.24C26.68 2.92 27.13 3.66 28.78 3.66H35.33L37 1.65H27.64Z"
        fill="#D40511"
      />
    </g>
  </svg>
)
export {DeliveryDhlIcon}
